const en = {
  // ==================== Common Labels ====================
  fullname: "Full Name",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  dateOfBirth: "Date Of Birth",
  phoneNumber: "Phone Number",
  mobileNumber: "Mobile Number",
  panNumber: "PAN Number",
  searchName: "Search Name",
  topicWisePerformance: "Topic-Wise Performance Insights",
  strong: "Strong",
  weak: "Weak",
  category: "Category",
  fromDate: "From Date",
  toDate: "To Date",
  fromTime: "From Time",
  toTime: "To Time",
  description: "Description",
  subject: "Subject",
  name: "Name",
  appliedDate: "Applied Date",
  staffType: "Staff type",
  allClass: "All Class",
  allSection: "All Section",
  allSchool: "All School",
  allMembers: "All Members",
  noFileChosen: "No file chosen",
  chooseFile: "Choose File",
  subjectList: "Subject List",
  subjectName: "Subject Name",
  groupName: "Group Name",
  groupList: "Group List",
  yes: "Yes",
  no: "No",
  empId: "Emp ID",
  email: "Email",
  mobileNo: "Mobile No",
  courses: "Courses",
  pageFrom: "Page From",
  pageTo: "Page To",
  dayScheduleListTitle: "Day Schedule List",
  classLabel: "Class",
  sectionLabel: "Section",
  unit: "Units",
  chapter: "Chapter",
  shortDescription: "Short Description",
  class: "Class",
  section: "Section",
  day: "Day",
  date: "Date",
  teacher: "Teacher",
  total: "Total",
  time: "Time",
  action: "Action",
  batch: "Batch",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",
  pincode: "Pincode",
  city: "City",
  country: "Country",
  state: "State",
  searchEmail: "Search Email",
  searchClass: "Search Class",
  searchSection: "Search Section",
  searchGender: "Search Gender",
  startDate: "Start Date",
  endDate: "End Date",
  includeSubject: "Include Subject",
  durationHrs: "Duration (hrs)",
  startTime: "Start Time",
  endTime: "End Time",
  duration: "Duration",
  publishMarkList: "Publish Mark List",
  publishMarkView: "Publish Mark View",
  subjects: "Subjects",
  totalMark: "Total Mark",
  rank: "Rank",
  dates: "Dates",
  votesPolled: "Votes Polled",
  publishView: "Publish View",
  staffLabel: "Staff",
  noteLabel: "Note",
  messagingLabel: "Messaging",
  birthdayDescription:
    "Birthdays are not ordinary days 🎂 🎁 🎊 🎉 Celebrate – That is the day one saw the light & world on their own !! 🎈 👶 Wish your teachers, colleagues & friends on their special day. 🤩",
  type: "Type",
  completionDate: "Completion Date",
  completionMonth: "Completion Month",
  medium: "Medium",
  totalCapacity: "Total Capacity",
  parent: "Parent",
  eligibleForHigherStudies: "Eligible for Higher Studies",
  attachedDocumentType:
    "Attached Document (Transfer Certificate / Record Sheet)",
  document: "Document",
  classes: "Classes",
  place: "Place",
  resendOtp: "Resend OTP",
  otpExpiresIn: "OTP expires in",
  feedback: "Feedback",
  group: "Group",
  changeSectionOptional: "Change Section (Optional)",
  feedbackRemarks: "Feedback / Remarks",
  totalPages: "Total Pages",
  subjectMedium: "Subject Medium",
  onAnyTopicToViewPages: "on any topic to view its pages here",
  scheduledDate: "Scheduled Date",
  userName: "User Name",
  updatedOn: "Updated On",
  comments: "Comments",
  schedule: "Schedule",
  minPageShort: "Min",
  maxPageShort: "Max",
  startPageLabel: "Start Page",
  endPageLabel: "End Page",
  scheduleDate: "Schedule Date",
  completedDate: "Completed Date",
  modalSuccessTitle: "Success",
  modalFailedTitle: "Failed",
  andLabel: "and",
  title: "Title",
  createdDate: "Created Date",
  explanation: "Explanation",
  submittedDate: "Submitted Date",
  timeDurationMins: "Time Duration (mins)",
  generatingWithAi: "Generating with Gemini AI",
  copyPhoneAria: "Copy phone number",
  filterByClass: "Filter by class",
  note: "Note", // NEW
  confirm: "Confirm", // NEW
  filter: "Filter", // NEW
  noData: "No data available", // NEW
  noOfAssessment: "No. of Assessment",
  totalStudent: "Total Student",
  showing: "Showing",
  to: "to",
  of: "of",
  entries: "entries",

  // ==================== Menu / Navigation Labels ====================
  changePassword: "Change Password",
  contentManagement: "Content Management",
  profile: "Profile",
  logout: "Logout",
  lastLogin: "Last Login",
  dashboard: "Dashboard",
  campusHub: "Campus Hub",
  admission: "Admission",
  birthday: "Birthday",
  workAnniversary: "Work Anniversary",
  capturePayment: "Capture Payment",
  admissionCycleConfig: "Admission Cycle Config",
  admissionSeatAllocationConfig: "Admission Seat Allocation Config",
  admissionApplicationList: "Admission Application List",
  captureInterviewDetails: "Capture Interview Details",
  annualAcademicTransition: "Annual Academic Transition",
  report: "Report",
  studentReport: "Student Report",
  attendanceReport: "Attendance Report",
  timeTable: "Time-Table",
  shift: "Shift",
  dayScheduleList: "Day Schedule List",
  timeTableView: "Time Table View",
  messaging: "Messaging",
  messagingSms: "Create Message",
  messagingEmail: "Manage Message",
  events: "Events",
  createEvent: "Create Event",
  eventCalendar: "Event Calendar",
  master: "Master",
  academicConfiguration: "Academic Configuration",
  staff: "Staff",
  holiday: "Holiday",
  bulkUpload: "Bulk Upload",
  syllabus: "Syllabus",
  receiver: "Receiver",
  botAttendance: "Bot Attendance",
  exam: "Exam",
  examConfiguration: "Exam Configuration",
  examRules: "Exam Rules",
  examRule: "Exam Rules",
  examSchedule: "Exam Schedule",
  examTimeTable: "Exam Time Table",
  examResult: "Exam Result",
  download: "Download",
  applicationDetails: "Application Details",
  attendanceDashboard: "Attendance",
  aiAssistant: "AI Assistant",
  aiDashboard: "AI Dashboard",
  admissionConfig: "admission-config",
  calendar: "Calendar",
  notifications: "Notifications",
  Subject: "Subject",
  Group: "Group",
  lessonPlanApprove: "Lesson Plan Approval",
  fees: "Fees",
  collectFees: "Collect Fees",
  paymentApproval: "Payment Approval",
  feeDashboard: "Fees Dashboard",
  dueFeeReport: "Due Fee Report",
  discountReport: "Discount Report",
  feesTransactionsReport: "Fees Transactions Report",
  settings: "Settings",
  schoolDetails: "School Details",
  manageAttendance: "Manage Attendance",
  monthlyAttendanceReport: "Monthly Attendance Report",
  createMessage: "Create Message",
  manageMessages: "Manage Messages",
  event: "Event",
  students: "Student",
  syllabus_submission: "Syllabus Submission",
  examTimetable: "Exam Time Table",
  examMarksEntry: "Exam Mark Entry",
  examResults: "Exam Result",
  publishMarks: "Publish Marks",
  timetable: "Time Table",
  assignment: "AI Assistant",
  LessonPlan: "Lesson Plan",
  studyHub: "Study Hub",
  payFees: "Pay Fees",

  // ==================== Settings Page Labels ====================
  feeModuleQr: "Fee Module QR",
  aiModuleKey: "AI Module AI Key",
  feeModuleQrRequired: "Fee Module QR is required",
  aiModuleKeyRequired: "AI Module AI Key is required",
  feeModuleQrSavedSuccess: "Fee Module QR saved successfully!",
  aiModuleKeySavedSuccess: "AI Module AI Key saved successfully!",

  // Plan / add-on gating
  feeModuleAddonRequired:
    "This feature is accessible only when you purchase the Fee Module add-on.",
  aiPlanRequired:
    "This feature is accessible only when you purchase the AI Plan.",

  // Status chips
  configured: "Configured",
  notConfigured: "Not Configured",

  // Bank QR card
  bankName: "Bank Name",
  qrCodeImage: "QR Code Image (PNG, JPEG)",
  addQrCode: "Add QR Code",
  newQrPreview: "New QR preview",
  currentQr: "Current QR",
  noQrConfigured:
    "No Bank QR Code configured yet. Add one so parents can scan and pay fees.",
  qrHelperNote: "Supported formats: PNG, JPG, JPEG. Max size 2MB.",
  bankNameRequired: "Bank Name is required",
  qrImageRequired: "QR Code image is required",
  qrImageSizeError: "QR image must not exceed 2MB",
  deleteQrConfirm: "The Bank QR Code will be removed from the Fee Module.",

  // AI key card
  aiKeyConfiguration: "AI Key Configuration",
  aiName: "AI Name",
  apiKey: "API Key",
  addAiKey: "Add AI Key",
  noAiConfigured:
    "No AI key configured yet. AI features (Add Book, Lesson Plan, Assessment, Remedial, Study Material) will use the default key.",
  aiKeyKeepNote: "Leave the API Key blank to keep the currently saved key.",
  aiDescriptionPlaceholder:
    "Gemini AI API key configuration for AI-powered educational features.",
  aiNameRequired: "AI Name is required",
  aiKeyRequired: "API Key is required",
  deleteAiConfirm:
    "AI features will fall back to the default key after deletion.",

  // ==================== Password Labels ====================
  oldPassword: "Old Password",
  newPassword: "New Password",
  retypeNewPassword: "Confirm New Password",
  updatePassword: "Update Password",

  // ==================== Profile Labels ====================
  profilePhoto: "Profile Photo",
  profileSetup: "Profile Setup",
  changeLanguage: "Change Language",
  maritalStatus: "Marital Status",
  single: "Single",
  married: "Married",
  spouseName: "Spouse Name",
  personalInfo: "Personal Information",
  locationBackground: "Location & Background",
  spiritualIdentification: "Spiritual & Identification",
  profileTitle: "Profile",

  // ==================== Academic Labels ====================
  startYear: "Start Year",
  endYear: "End Year",
  academicYear: "Academic Year",
  isUpcomingYear: "Is This Upcoming Year?",

  // ==================== Messaging Labels ====================
  managementTalk: "Management Talk",
  message: "Message",
  attachment: "Attachment",
  role: "Role",
  inbox: "INBOX",
  sentItems: "SENT ITEMS",
  selectMessageToViewDetails: "Select a message to view details",
  staffAccount: "Staff Account",
  studentAccount: "Student Account",
  parentAccount: "Parent Account",
  schoolCockpit: "School Cockpit",
  allStaff: "All Staff",
  teaching: "Teaching",
  administrative: "Administrative",
  management: "Management",
  hallOfFameEmptyMessage:
    "Announce winners and 🏆 celebrate the successes of your 🤓 👨‍🎓 students & teachers here... Recognition act as Energy Boosters 💪 😊",
  managementTalkEmptyMessage:
    "Cascade management's vision and goals 🤩 in this space to enable your institution to achieve goals and reach newer heights 🤞 🧑 👍",
  opinionPollEmptyMessage:
    'As they say "Students are pillars of the nation". Help them to start voicing their opinion 🤓 👆 on myriad of topics through our Poll Corner 🤟 😀',
  newsBlogsEmptyMessage:
    "Actively engage & educate your stakeholders – Students, Parents, Teachers & Staff and promote meaningful discussion on relevant topics ☝️ 🤪",
  enterOtpSentToEmail: "Enter the 6-digit OTP sent to your email",

  // ==================== Event Labels ====================
  school: "School",
  venue: "Venue",

  // ==================== Content Management Labels ====================
  hallOfFame: "Hall of Fame",
  newsAndBlogs: "News and Blogs",
  announcements: "Announcements",
  opinionPoll: "Opinion Poll",
  famePhoto: "Fame Photo",
  content: "Content",
  enter: "Enter",
  designation: "Designation",
  topicName: "Topic Name",

  // ==================== Student Labels ====================
  emailAddress: "Email Address",
  male: "Male",
  female: "Female",
  other: "Other",
  fatherName: "Father Name",
  motherName: "Mother Name",
  aadhaarNumber: "Aadhar Number",
  allStudents: "All Students",
  studentName: "Student Name",
  studentId: "Student id",
  totalStudents: "Total Students",
  location: "Location",
  address: "Address",
  district: "District",
  geographicCoordinates: "Geographic Coordinates",
  cityTownVillage: "City / Town / Village",
  student: "Student",
  emergencyContactNumber1: "Emergency Contact Number 1",
  emergencyContactNumber2: "Emergency Contact Number 2",
  familyDoctor: "Family Doctor",
  rollId: "Roll Id",
  aadharNumber: "Aadhar Number",
  gender: "Gender",
  religion: "Religion",
  bloodGroup: "Blood Group",
  medicalCondition: "Medical Condition",
  studentPhoto: "Student Photo",
  anniversary: "Anniversary",
  address1: "Address 1",
  address2: "Address 2",
  address3: "Address 3",
  occupation: "Occupation",
  income: "Income",
  relationType: "Relation Type",
  hospital: "Hospital",
  studentList: "Student List",
  searchStudentId: "Search Student ID",
  searchStudentName: "Search Student Name",
  searchBloodGroup: "Search Blood Group",
  studentsPassed: "Students Passed",
  workAnniversaryDescription:
    'They say "Experience is a great teacher"... 👆 📝 Wish your teachers & staff on their work anniversaries as they too grow wiser with experience... 🧑 🧔 👨‍🦰',
  studentPassed: "Students Passed",
  studentImage: "Student Image",
  studentsList: "Students List",

  // ==================== Admission Labels ====================
  admissionInterviewSchedule: "Admission Interview Schedule",
  interviewSchedule: "Interview Schedule",
  seatAllocationApplication: "Seat Allocated Application List",
  applicationId: "Application ID",
  backAdmissionApplicationList: "Back to Admission Application List",
  totalPromoted: "Total Promoted",
  totalDetained: "Total Detained",
  publishAnnualTransition: "Publish Annual Transition",
  updatePromotionStatus: "Update Promotion Status",
  passFail: "Pass/Fail",
  assignSection: "Assign Section",
  uploadNewOfflineApplicationFile: "upload New Offline Application File",
  isChildStayingWithGuardian: "Is the Child Staying with Guardian?",
  pleaseAttachMedicalCertificate: "Please Attach Medical Certificate",
  admissionName: "Admission Name",
  admissionType: "Admission Type",
  admissionStartDate: "Admission Start Date",
  admissionEndDate: "Admission End Date",
  screeningStartDate: "Screening Start Date",
  screeningEndDate: "Screening End Date",
  interviewStartDate: "Interview Start Date",
  interviewEndDate: "Interview End Date",
  seatAllocationConfiguration: "Seat Allocation Configuration",
  searchSeatConfig: "Search ...",
  studentNameTamil: "Student's Name (Tamil)",
  studentNameEnglish: "Student's Name (English)",
  dobInWords: "DOB in Words",
  caste: "Caste",
  nationality: "Nationality",
  areYouResidingWith: "Are you residing with parents or with a guardian?",
  guardian: "Guardian",
  annualIncome: "Annual Income",
  lastStudiedDetails: "Last Studied Details",
  lastStudiedClass: "Last Studied Class",
  lastStudiedSchool: "Last Studied School",
  lastStudiedMedium: "Last Studied Medium",
  emisNo: "EMIS No",
  preferredCourseDetails: "Preferred Course Details",
  preferredClassForAdmission: "Preferred Class for Admission",
  motherTongue: "Mother Tongue",
  preferredFirstLanguageToStudy: "Preferred First Language to Study",
  preferredMediumToStudy: "Preferred Medium to Study",
  smallpoxVaccinationTaken: "Smallpox Vaccination Taken?",
  previousSchoolAddress: "Previous School Address",
  schoolName: "School Name",
  yearOfStudy: "Year of Study",
  mediumOfInstruction: "Medium of Instruction",
  identificationMarksOnBody: "Identification Marks on the Body",
  identificationMark1: "Identification Mark 1",
  identificationMark2: "Identification Mark 2",
  admissionApplicationForm: "Admission Application Form",
  applicationPreview: "Application Preview",
  formXItoXII: "Form - XI to XII",
  formItoX: "Form - I to X",
  birthPlace: "Birth Place",
  communityCertificate: "Community Certificate",
  preferredStudyCourse: "Course Preferred to Study",
  yearOfAdmission: "Year of Admission (First Year / Second Year)",
  firstYear: "First",
  secondYear: "Second",
  preferredGroup1: "Preferred Group 1",
  preferredGroup2: "Preferred Group 2",
  preferredGroup3: "Preferred Group 3",
  mediumOfInstructionLeavingSchool:
    "Medium of Instruction at the Time of Leaving School",
  studiedYear: "Year of Study",
  nccNssScoutsGuides:
    "NCC / NSS / Scouts / Guides / Red Cross – Would you like to join?",
  certificatesForCoCurricular: "Certificates for Co-curricular Activities",
  taluk: "Taluk",
  secondaryVItoIX: "SECONDARY – VI TO IX",
  higherSecondaryXI: "HIGHER SECONDARY – XI",
  checklist: "Checklist",
  secondaryOnlineApplication: "Secondary Online Application",
  tamilKeyboard: "Tamil Keyboard",
  withParents: "With Parents",
  withGuardian: "With Guardian",
  documentToBeUploaded: "Document to be Uploaded",
  studentMotherTongue: "Student Mother Tongue",
  preferredMediumOfInstruction: "Preferred Medium of Instruction",
  assignedGroup: "Assigned Group",
  preferredGroup: "Preferred Group",
  higherSecondaryOnlineApplication: "Higher Secondary Online Application",
  higherSecondaryApplication: "Higher Secondary Application",
  assignedClass: "Assigned Class",
  assignedSection: "Assigned Section",
  checkList: "Check List",
  checklistItems: "Checklist Items",

  // ==================== Exam / Assessment Labels ====================
  markSheet: "Mark Sheet",
  predictedScore: "Predicted Score",
  actualScore: "Actual Score",
  examTypePlaceholde: "Select Exam Type",
  examType: "Exam Type",
  examName: "Exam Name",
  allExams: "All Exams",
  isAnnualExam: "Is This an Annual Exam?",
  examPassRules: "Exam Pass Rules",
  theory: "Theory",
  practical: "Practical",
  examMode: "Exam Mode",
  dateOfExam: "Date of Exam",
  passMark: "Pass Mark",
  maximumMark: "Maximum Mark",
  examScheduleList: "Exam Schedule List",
  modeOfExam: "Mode of Exam",
  maxMark: "Max Mark",
  selectExamAndClass: "Please select Exam Name to view the timetable",
  markBulkUpload: "Mark Bulk Upload",
  passedPercentage: "Passed Percentage",
  failedPercentage: "Failed Percentage",
  passesdPercentage: "Passed Percentage",
  qualifyingExaminationPassed: "Qualifying Examination Passed",
  nameOfExaminationBoard: "Name of the Examination Board",
  publicExaminationMarks: "Public Examination Marks",
  nameOfExaminationPassed: "Name of the Examination Passed",
  monthAndYearOfExamination: "Month and Year of Examination",
  examinationRegisterNumber: "Examination Register Number",
  marksObtained: "Marks Obtained",
  maxMarks: "Max Marks",
  overall: "Overall",
  percentage: "Percentage",
  subjectWiseScorePrediction: "Subject wise Score Prediction",
  assessment: "Assessment",
  remedialAssessment: "Remedial Assessment",
  questionsCount: "Questions Count",
  questionCount: "Questions Count",
  difficultyLevel: "Difficulty Level",
  mcqOptionsCount: "MCQ Options Count",
  passPercentage: "Pass Percentage",
  previewAssessment: "Preview Assessment",
  failedToGenerateAssessment: "Failed to generate assessment",
  failedToSaveAssessment: "Failed to save assessment",
  numberOfQuestion: "Number of Question",
  academicHealthScore: "Academic Health Score",
  assessmentProgressTracker: "Assessment Progress Tracker",
  classAverageEngagementScore: "Class Average Engagement Score",
  subjectWiseEngagementScore: "Subject wise Engagement Score",
  engagementScore: "Engagement Score",
  myScore: "My Score",
  classTopperScore: "Class Topper Score",

  // ==================== Attendance Labels ====================
  workingDays: "Working Days",
  attendance: "Attendance",
  attendanceList: "Attendance List",
  studentAttendanceMonthlyView: "Student Attendance Monthly View",
  attendancePercentage: "Attendance(%)",
  classStrength: "Class Strength",
  totalWorkingDaysYear: "Total Working Days (Year)",
  totalPresentYear: "Total Present (Year)",
  totalAbsentYear: "Total Absent (Year)",
  attendancePercentageYear: "Attendance Percentage (Year)",
  totalWorkingDaysMonth: "Total Working Days (Month)",
  totalPresentMonth: "Total Present (Month)",
  totalAbsentMonth: "Total Absent (Month)",
  attendancePercentageMonth: "Attendance Percentage (Month)",
  todayDate: "Today Date",
  today: "today",
  calendarMonth: "month",
  calendarWeek: "week",
  calendarDay: "day",
  studentAttendanceDashboard: "Student Attendance Dashboard",
  staffAttendanceDashboard: "Staff Attendance Dashboard",
  attendanceLogs: "Attendance Logs",
  attendanceRate: "Attendance Rate",
  dailyAttendance: "Daily Attendance",
  todayAbsentee: "Today Absentee",
  classAttendanceTrend: "Class Attendance Trend",
  assessmentTrend: "Assessment Trend",
  studentAttendanceTrend: "Student Attendance Trend",
  teacherAttendanceTrend: "Teacher Attendance Trend",

  // ==================== Leave Labels ====================
  leaveList: "Leave List",
  leaveCreate: "Apply Leave",
  noOfDaysLeave: "No. of Days",
  reason: "Reason",
  leaveRequest: "Leave Request",
  child: "Child",
  sickLeave: "Sick Leave",
  fever: "Fever",
  familyFunction: "Family Function",
  medical: "Medical",
  personal: "Personal",
  others: "Others",
  classTeacherRemark: "Class Teacher Remark",
  reasonForWithdraw: "Reason For Withdraw",
  reasonForLeaving: "Reason for Leaving or Discontinuation",

  // ==================== Holiday Labels ====================
  holidayType: "Holiday Type",
  searchHolidayType: "Search Holiday Type",

  // ==================== Shift / Timetable Labels ====================
  shiftConfigurationList: "Shift Configure List",
  shiftLabel: "Shift",
  shift1: "SHIFT 1",
  shift2: "SHIFT 2",
  period: "Period",
  periodSubject: "Period Subject",
  shiftName: "Shift Name",
  numberOfBreaks: "No. of Breaks",
  numberOfPeriods: "No. of Periods",
  breakType: "Break Type",
  periodName: "Period Name",
  break: "Break",

  // ==================== Book Labels ====================
  book: "Book",
  bookList: "Book List",
  term: "Term",
  volume: "Volume",
  topic: "Topic",
  subTopic: "Sub Topic",
  start: "Start",
  end: "End",
  bookPages: "Book Pages",
  pdfPages: "PDF Pages",
  clickEyeIconToView: "Click the",
  eyeIcon: "eye icon",
  page: "Page",
  bookDetails: "Book Details",
  contentStartPage: "Content Start Page",
  contentEndPage: "Content End Page",
  bookFirstPageNo: "Book First Page No.",
  pdfPageOfBookFirstPageNo: "PDF Page of Book First Page No.",
  printedPageOnFirstContentPage: "Printed page number on first content page",
  openPdfInViewer:
    "Open PDF in viewer, find the page showing above number, enter that PDF page number",
  contentsPage: "Contents Page",

  // ==================== Lesson Plan Labels ====================
  examTimeTableList: "Exam Time Table List",
  tabAll: "All",
  tabSubmitted: "Submitted",
  tabApproved: "Approved",
  tabRejected: "Rejected",
  tabClasswise: "Class-wise",
  tabTeacherwise: "Teacher-wise",
  toggleAll: "All",
  toggleThisWeek: "This week",
  studyMaterial: "Study Material",
  savedLessonPlan: "Saved Lesson Plan",
  lessonPlan: "Lesson Plan",
  breadcrumbSeparator: "/",
  breadcrumbAriaLabel: "Breadcrumb",
  weeklyScheduleTitle: "Weekly Schedule",
  scheduleGridEmpty: "Select a schedule date to view the timetable",
  periodRoman: "Period",
  legendSubmitted: "Submitted",
  legendApproved: "Approved",
  legendRejected: "Rejected",
  legendResubmitted: "Re-Submitted",
  cellEmpty: "---",
  lessonPlanEditorTitle: "Lesson Plan Editor",
  bookPdfTitle: "Book PDF",
  pdfFallbackMessage: "PDF will appear here",
  failedToSaveLessonPlan: "Failed to save lesson plan.",
  failedToGenerateLessonPlan: "Failed to generate lesson plan.",
  socialScienceSample: "Social Science",
  classSectionSample: "VI - A",
  lessonPeriodSlot1: "09:30 am - 10:15 am",
  lessonPeriodSlot2: "10:15 am - 11:00 am",
  lessonPeriodSlot3: "11:15 am - 12:00 pm",
  lessonPeriodSlot4: "12:00 pm - 12:45 pm",
  lessonPeriodSlot5: "01:30 pm - 02:15 pm",
  lessonPeriodSlot6: "02:15 pm - 03:00 pm",
  lessonPeriodSlot7: "03:15 pm - 04:00 pm",
  lessonPeriodSlot8: "04:00 pm - 04:45 pm",
  legendCompleted: "Completed",
  loadingTimetable: "Loading timetable...",
  failedToScheduleLessonPlan: "Failed to schedule lesson plan",
  weeklyTimetable: "Weekly Timetable",
  studyMaterialAlreadyGenerated:
    "Study material already generated for this student",
  failedToDeleteStudyMaterial: "Failed to discard study material",
  studyMaterialDeleted: "Study material discarded successfully",
  // ==================== Fees Modules Labels ====================
  amountPercentage: "Amount / Percentage",
  code: "Code",
  types: "Types",
  createFeeDiscount: "Create Fee Discount",
  createFeeAssign:"Create Fee Assign",
  editFeeDiscount: "Edit Fee Discount",

  createFeeType: "Create Fee Type",
  editFeeType: "Edit Fee Type",

  feeType: "Fees Type",
  feeDiscount: "Fee Discount",
  deleteFeeType: "Delete Fee Type",
  deleteFeeDiscount: "Delete Fee Discount",
  enterFeeType: "Enter Fee Type",
  enterFeeCode: "e.g:TUI00I",
  enterDescription: "Enter Description (Max:100 words)",
  searchNameCode: "Search Name & code",
  searchClassSection: "Search Class & Section",
  unAssignStudents: "Unassigned Students",
  feeAssign: " Assign Fees",


  // ==================== Dashboard Labels ====================
  subjectEngagementRiskAnalysis: "Subject Engagement Risk Analysis",
  month: "Month",
  staffDirectory: "Staff Directory",
  staffName: "Staff Name",
  contact: "Contact",
  myChild: "My Child",
  source: "Source",
  birthdayTitle: "Birthday!",
  workAnniversaryTitle: "Work Anniversary!",
  switchToStaffDashboard: "Switch to Staff Dashboard",
  switchToStudentDashboard: "Switch to Student Dashboard",
  performanceOverview: "Performance Overview",
  dataset1: "Dataset 1",
  clickBarForSubjectBreakdown: "Click any bar to view subject-wise breakdown",
  subjectBreakdownClickXToGoBack: "Subject-wise breakdown - click X to go back",
  assessmentTrendNote:
    "Click a point to view student-wise assessment status; hover for exact values.",
  subjectWiseSuffix: "(Subject-wise)",
  remedialProgressTracker: "Remedial Progress Tracker",
  weekly: "Weekly",
  monthly: "Monthly",
  yearly: "Yearly",
  week: "Week",
  year: "Year",
  onTrackAlerts: "On Track Alerts",
  needsAttentionAlerts: "Needs Attention Alerts",
  noAlerts: "No alerts to display",
  syllabusCompletion: "Syllabus Completion Percentage",
  totalTeachers: "Total Teachers",

  // ==================== Report Labels ====================
  staffDefectList: "Staff Defect List",
  studentDefectList: "Student Defect List",
  defectList: "Defect List",

  // ==================== Table Labels ====================
  image: "Image",
  rowsPerPage: "Rows per page",
  noOfSection: "No. of Sections",
  fileName: "File Name",
  sizeKb: "Size(kb)",
  lastModified: "Last Modified",
  actions: "Actions",
  serialNo: "S.No",
  noOfDays: "No. of Days",
  noOfBreak: "No. of Breaks",
  noOfPeriods: "No. of Periods",
  noOfMale: "No. of Male",
  noOfFemale: "No. of Female",
  totalNoOfStudent: "Total No. of Students",
  dayPeriodHeader: "Day / Period",
  actionHeader: "Action",

  // ==================== Form Labels ====================
  optional: "(Optional)",
  fatherInformation: "Father Information",
  motherInformation: "Mother Information",
  guardianInformation: "Guardian Information",
  sameAddress: "(Same Address)",
  studentDetails: "Student Details",
  basicDetails: "Basic Details",
  residentialDetails: "Residential Details",
  otherDetails: "Other Details",
  academicDetails: "Academic Details",
  marksTable: "Marks Table",
  statusDetails: "Status Details",
  breakDetails: "Break Details",
  periodDetails: "Period Details",
  tableOfContents: "Table of Contents",
  generatedTableOfContents: "Generated Table of Contents",

  // ==================== Button / Action Labels ====================
  copy: "copy",
  readMoreLink: "Read More Link",
  select: "Select",
  retry: "Retry",
  send: "SEND",
  loading: "Loading...",
  cancel: "CANCEL",
  submit: "SUBMIT",
  update: "UPDATE",
  submitting: "Submitting...",
  updating: "Updating...",
  uploadYourFile: "Upload your file here",
  downloadSampleFile: "DOWNLOAD THE SAMPLE FILE",
  import: "IMPORT",
  viewAction: "View",
  viewDayScheduleTitle: "Create Day Schedule",
  editDayScheduleTitle: "Edit Day Schedule",
  all: "All",
  add: "ADD",
  edit: "EDIT",
  back: "BACK",
  adding: "Adding...",
  delete: "DELETE",
  view: "VIEW",
  save: "SAVE",
  deleting: "Deleting...",
  updateButton: "Update",
  saving: "Saving...",
  createButton: "Create",
  cancelButton: "Cancel",
  saveButton: "Save",
  searchButton: "Search",
  resetButton: "Reset",
  checkExamButton: "Check Exam",
  refreshButton: "Refresh",
  addSyllabus: "ADD SYLLABUS",
  clear: "Clear",
  downloadExcel: "DOWNLOAD EXCEL",
  editProfile: "Edit Profile",
  backToProfile: "Back to Profile",
  saveProfile: "Save Profile",
  saveToDraft: "Save to Draft",
  addButton: "ADD",
  downloadButton: "DOWNLOAD",
  viewStudent: "View Student",
  createExamSchedule: "Create Exam Schedule",
  editExamSchedule: "Edit Exam Schedule",
  downloadFrameSet: "DOWNLOAD THE FRAME SET",
  uploadFrameSet: "UPLOAD FRAME SET",
  uploading: "Uploading...",
  uploadMarksheet: "Upload Marksheet",
  publish: "PUBLISH",
  createAttendance: "Create Attendance",
  editAttendance: "Edit Attendance",
  upload: "UPLOAD",
  approve: "Approve",
  reject: "Reject",
  seeAll: "See All",
  readFullSpeech: "Read Full Speech",
  verifyApplication: "Verify Application",
  confirmAndSubmit: "Confirm & Submit",
  withdrawApplication: "Withdraw Application",
  offlineApplication: "+ Offline Application",
  allocateSeat: "Allocate Seat",
  moveToDropped: "Move to Dropped",
  bulkChangeStatus: "Bulk Change Status",
  proceed: "Proceed",
  updateChanges: "Update Changes",
  deletegroup: "Delete Group",
  approveApplication: "Approve Application",
  rejectStudents: "Reject Students",
  createShift: "Create Shift",
  editShift: "Edit Shift",
  deleteShift: "Delete Shift",
  viewBook: "View Book",
  fullPdf: "FULL PDF",
  prev: "Prev",
  next: "Next",
  addBook: "Add Book",
  editBook: "Edit Book",
  generateTableOfContents: "Generate Table of Contents",
  uploadBookPdf: "Upload Book (PDF)",
  viewUploadedBook: "VIEW UPLOADED BOOK",
  backToAddBook: "BACK TO ADD BOOK",
  close: "Close",
  viewLessonPlan: "View Lesson Plan",
  createLessonPlan: "Create Lesson Plan",
  editLessonPlan: "Edit Lesson Plan",
  generatingLessonPlan: "Generating...",
  generateLessonPlan: "Generate Lesson Plan",
  regenerateLessonPlan: "Re-Generate",
  saveAsDraft: "Save as Draft",
  submitToHM: "Submit to HM",
  scheduleLessonPlan: "Schedule Lesson Plan",
  viewAssessment: "View Assessment",
  viewRemedialAssessment: "View Remedial Assessment",
  viewStudyMaterial: "View Study Material",
  generateAssessment: "Generate Assessment",
  generateremedialAssessment: "Generate Remedial Assessment",
  generating: "Generating...",
  generate: "Generate",
  regenerate: "Re-Generate",
  viewResult: "View Result",
  createRemedialAssessment: "Create Remedial Assessment",
  createStudyMaterial: "Create Study Material",
  ok: "OK",
  viewAll: "View All",

  // ==================== Status Labels ====================
  inviteStatus: "Invite Status",
  annualTransitionStatus: "Annual Transition Status",
  TransitionCompleted: "Transition Completed",
  TransitionNotCompleted: "Transition Not Completed",
  success: "Success",
  failed: "Failed",
  status: "Status",
  present: "Present",
  absent: "Absent",
  leave: "Leave",
  active: "Active",
  inactive: "Inactive",
  published: "PUBLISHED",
  verified: "Verified",
  notVerified: "Not Verified",
  accepted: "ACCEPTED",
  rejected: "REJECTED",
  withdrawn: "WITHDRAWN",
  pending: "PENDING",
  submitted: "SUBMITTED",
  enrolled: "Enrolled",
  seatAllocated: "Seat Allocated",
  approved: "Approved",
  rejectedSmall: "Rejected",
  alreadySeatAllocated: "Already Seat Allocated",
  currentStatus: "Current Status",
  hold: "Hold",
  updatedStatus: "Updated Status",
  resubmitted: "Resubmitted",
  completed: "Completed",
  draft: "Draft",
  statusApproved: "Approved",
  statusCompleted: "Completed",
  pass: "Pass",
  fail: "Fail",
  passed: "Passed",
  unattended: "Unattended",

  // ==================== Modal / Dialog Labels ====================
  subjectEngagementNote:
    "Click on any segment of the chart to view the students included in that category. The student list will be displayed based on the selected segment.",
  confirmDeleteSchedule: "Are you sure you want to delete this schedule?",
  confirmDeleteTimeTable: "Are you sure you want to delete this timetable?",
  examConfigEditNote:
    "The exam schedule has already been created. Editing the Status is not allowed.",
  confirmDelete: "Are you sure you want to delete?",
  examRulesNote:
    "Only Students who meet the passing criteria will be eligible for ranking.",
  toDateResetWarning: "To Date was reset as it was before From Date",
  parentGuardianAffidavit: "Parent / Guardian Affidavit",
  iAgreeToAboveStatements: "I have read and agree to the above statements.",
  affidavitLine1:
    "I hereby undertake that my Son/Daughter shall strictly adhere to the rules and regulations of the school.",
  affidavitLine2:
    "In case of any misconduct, I agree to request and obtain the Transfer Certificate.",
  affidavitLine3:
    "I hereby certify that the above details are correct to the best of my knowledge.",
  affidavitLine4:
    'I further affirm that my son/daughter has not been enrolled in or studied at any school other than the one specified under "Previous School Address".',
  affidavitLine5:
    "I hereby declare that the date of birth and community details furnished in the admission application are true and correct.",
  affidavitLine6:
    "I further undertake that I will not apply for or request any change in these particulars at any time in the future.",
  publicMarksNote:
    "The marks obtained in the qualifying examination must be duly attested either by the Headmaster of the school last studied or by a Gazetted Officer. The original mark certificate should NOT be sent along with the application. Only the attested copy of the mark statement should be enclosed with the application. The original mark statement must be produced at the time of admission.",
  preferredCourseNote:
    "Please specify the order of preference for the stream you wish to study.",
  parentGuardianPledge: "Parent / Guardian Pledge",
  pledgeLine1:
    "I hereby declare that the particulars furnished above are true and correct to the best of my knowledge, and that I shall abide by the rules and regulations of the school.",
  pledgeLine2:
    "I am aware that if the admission is found to have been obtained based on false information or by suppressing facts, it is liable to be cancelled at any time.",
  pledgeLine3:
    "I further undertake to follow the school discipline, and in case of any violation, I agree to apply for and obtain the Transfer Certificate.",
  pledgeNote: "Note:",
  pledgeNote1:
    "Submit originals at the time of admission and keep photocopies.",
  pledgeNote2:
    "Certificates will not be returned once the student leaves school.",
  instructions: "Instructions",
  feedbackRecordedFor: "This feedback will be recorded for {count} student(s).",
  areYouSure: "Are you sure?",
  confirmStatusChange: "Are you sure? Change status from '{from}' to '{to}'?",
  seatAllocateConfirm:
    "You can seat allocate only once at a time. Do you want to continue?",
  moveToDroppedConfirm: "Are you sure you want to move to dropped?",
  studyMaterialGeneratedCancelConfirm:
    "Study material has been generated. Are you sure you want to cancel and discard it?",

  // ==================== Placeholder Labels ====================
  eventPlaceholder: "Select Event section",
  venuePlaceholder: "Enter venue",
  descriptionPlaceholder: "Enter description",
  shortDescriptionPlaceholder: "Enter short description",
  schoolPlaceholder: "Enter School",
  oldPasswordPlaceholder: "Enter old password",
  newPasswordPlaceholder: "Enter new password",
  confirmPasswordPlaceholder: "Enter confirm password",
  selectLanguage: "Select Language",
  selectMaritalStatus: "Select Marital Status",
  spouseNamePlaceholder: "E.g. Spouse Name",
  fatherNamePlaceholder: "E.g. Father Name",
  motherNamePlaceholder: "E.g. Mother Name",
  selectAdmissionType: "Select admission type",
  selectSchoolPlaceholder: "Select school",
  messagePlaceholder: "Enter message",
  selectAcademicYear: "Select Academic Year",
  selectDate: "Select Date",
  startYearPlaceholder: "E.g. 2025",
  endYearPlaceholder: "E.g. 2026",
  subjectPlaceholder: "Select subject",
  grouPlaceholder: "Select group name",
  classPlaceholder: "Select Class",
  sectionPlaceholder: "Select Section",
  shiftPlaceholder: "Select Shift",
  selectsubjectPlaceholder: "Select subject",
  periodSubjectPlaceholder: "Period Subject",
  selectMonth: "Select Month",
  firstNamePlaceholder: "E.g. First Name",
  middleNamePlaceholder: "E.g. Middle Name",
  lastNamePlaceholder: "E.g. Last Name",
  rollIdPlaceholder: "E.g. 10102004001",
  emailPlaceholder: "E.g. student@gmail.com",
  fatherEmailPlaceholder: "E.g. father@gmail.com",
  motherEmailPlaceholder: "E.g. mother@gmail.com",
  guardianEmailPlaceholder: "E.g. guardian@gmail.com",
  emailAddressPlaceholder: "E.g. Email Address",
  emailAltPlaceholder: "E.g. Email",
  dateOfBirthPlaceholder: "Ex: 30/07/2016",
  aadharNumberPlaceholder: "E.g. Aadhar Number",
  aadharNumberAltPlaceholder: "Ex: 43215678907",
  selectGender: "Select Gender",
  selectClass: "Select Class",
  selectSection: "Select Section",
  selectReligion: "Select Religion",
  selectCategory: "Select Category",
  selectBloodGroup: "Select Blood Group",
  medicalConditionPlaceholder: "E.g. Medical Condition",
  photoPlaceholder: "E.g. Mypic.jpg",
  phoneNumberPlaceholder: "E.g. Phone Number",
  phoneNoPlaceholder: "E.g. Phone No",
  mobileNumberPlaceholder: "E.g. Mobile Number",
  panNumberPlaceholder: "Ex: 678909XYZ",
  addressPlaceholder: "E.g. Address",
  pincodePlaceholder: "E.g. Pincode",
  cityPlaceholder: "E.g. City",
  selectCountry: "Select Country",
  selectState: "Select State",
  selectOccupation: "Select Occupation",
  selectIncome: "Select Income",
  selectRelation: "Select Relation",
  hospitalPlaceholder: "E.g. Hospital",
  examNamePlaceholder: "E.g. Half Yearly Exam",
  selectExamName: "Select Exam Name",
  startDatePlaceholder: "Ex: 30/07/2024",
  endDatePlaceholder: "Ex: 30/08/2024",
  selectModeOfExam: "Select Mode",
  selectChild: "Select Child",
  selectReason: "Select Reason",
  notePlaceholder: "E.g. Enter your messages",
  selectStatus: "Select Status",
  selectLeaveType: "Select Leave Type",
  enterYourMessages: "E.g. Enter your messages",
  selectType: "Select Type",
  enterHere: "Enter here..",
  studentNameTamilPlaceholder: "Enter Student Name in Tamil",
  studentNameEnglishPlaceholder: "Enter Student Name in English",
  dobInWordsPlaceholder: "E.g. Twenty-Sixth December...",
  castePlaceholder: "E.g. Caste",
  nationalityPlaceholder: "E.g. Indian",
  annualIncomePlaceholder: "e.g., 250000",
  districtPlaceholder: "E.g. District",
  emisNoPlaceholder: "E.g. 1212121212",
  selectPreferredClass: "Select Preferred Class",
  selectMotherTongue: "Select Mother Tongue",
  selectYear: "Select Year",
  birthPlacePlaceholder: "E.g. Chennai",
  selectExamination: "Select Examination",
  selectCoursePrefered: "Select Course Preferred",
  selectPreferredGroup1: "Select Preferred Group 1",
  selectPreferredGroup2: "Select Preferred Group 2",
  selectPreferredGroup3: "Select Preferred Group 3",
  reasonForLeavingPlaceholder: "Enter reason for leaving or discontinuation",
  talukPlaceholder: "E.g. Taluk",
  groupPlaceholder: "E.g. Group A",
  feedbackRemarksPlaceholder: "Enter feedback / remarks",
  shiftNamePlaceholder: "Enter shift name (e.g., Morning Shift)",
  numberOfBreaksPlaceholder: "Enter number of breaks (0-10)",
  numberOfPeriodsPlaceholder: "Enter number of periods (1-20)",
  breakTypePlaceholder: "Enter break type (e.g., Lunch, Coffee)",
  periodNamePlaceholder: "Enter period name (e.g., Work Session, Meeting)",
  selectTopicToView: "Select a topic to view",
  selectMedium: "Select Medium",
  selectTerm: "Select Term",
  selectVolume: "Select Volume",
  enterContentStartPage: "Enter Content Start Page",
  enterContentEndPage: "Enter Content End Page",
  enterBookPDFNumber: "Enter Book PDF Number",
  selectClassFirst: "Select Class First",
  selectBook: "Select Book",
  selectTopicPlaceholder: "Select Topic",
  selectSubTopic: "Select Sub Topic",
  enterStartPage: "Enter Start Page",
  enterEndPage: "Enter End Page",
  lessonPlanEditorPlaceholder: "Generated lesson plan will appear here...",
  selectDifficulty: "Select Difficulty",
  enterOptionsCount: "Enter Options Count",
  selectPassPercentage: "Select",
  enterNumberOfQuestions: "Enter Number of Questions",
  selectBookFirst: "Select Book First",
  selectTopicFirst: "Select Topic First",

  // ==================== Validation Labels ====================
  markSheetRequired: "Mark Sheet is required",
  isActiveRequired: "Status is required",
  nameRequired: "Name is required",
  dateRequired: "Date is required",
  dateMustBeTodayOrFuture: "Date must be today or a future date",
  fromTimeRequired: "From Time is required",
  toTimeRequired: "To Time is required",
  toTimeMustBeAfterFromTime: "To Time must be after From Time",
  venueRequired: "Venue is required",
  selectAtLeastOneStudent:
    "Please select at least one student from the Seat Allocated Application List",
  firstNameRequired: "First name is required",
  lastNameRequired: "Last name is required",
  fatherNameRequired: "Father name is required",
  mobileNumberRequired: "Mobile number is required",
  mobileNumberInvalid: "Enter valid 10-digit mobile number",
  bloodGroupRequired: "Blood group is required",
  genderRequired: "Gender is required",
  aadharNumberInvalid: "Enter valid 12-digit Aadhar number",
  dateOfBirthRequired: "Date of birth is required",
  pincodeRequired: "Pincode is required",
  pincodeInvalid: "Enter valid 6-digit pincode",
  addressRequired: "Address is required",
  cityRequired: "City is required",
  stateRequired: "State is required",
  countryRequired: "Country is required",
  languageRequired: "Language is required",
  incomeRequired: "Income is required",
  maritalStatusRequired: "Marital status is required",
  anniversaryRequired: "Anniversary is required",
  spouseNameRequired: "Spouse name is required",
  staffTypeRequired: "Staff Type is required",
  studentRequired: "Student is required",
  teacherRequired: "Teacher is required",
  onlyImageFilesAllowed: "Only jpg, jpeg, png, gif files are allowed",
  schoolRequired: "School is required",
  roleRequired: "Role is required",
  subjectRequired: "Subject is required",
  messageRequired: "Message is required",
  startYearRequired: "Start Year is required",
  startYearInvalid: "Please enter a valid year (e.g., 2025)",
  endYearRequired: "End Year is required",
  endYearInvalid: "Please enter a valid year (e.g., 2026)",
  endYearGreater: "End Year must be greater than Start Year",
  fromDateRequired: "From Date is required",
  fromDateYearMismatch: "From Date must match the Start Year",
  toDateRequired: "To Date is required",
  toDateYearMismatch: "To Date must match the End Year",
  toDateAfter: "To Date must be after From Date",
  isUpcomingYearRequired: "Is This Upcoming Year is required",
  selectAllStudentsToVerify: "Please select all students to verify.",
  panNumberInvalid: "Enter valid PAN number (Ex: ABCDE1234F)",
  examTypeRequired: "Exam Type is required",
  examNameRequired: "Exam Name is required",
  startDateRequired: "Start Date is required",
  endDateRequired: "End Date is required",
  endDateAfterStart: "End Date must be after Start Date",
  passRulesRequired: "At least one pass rule must be selected",
  classRequired: "Class is required",
  sectionRequired: "Section is required",
  includeAtLeastOneSubject: "Please include at least one subject",
  fillRequiredSubjectFields:
    "Please fill Date of Exam, From Time, and To Time for all included subjects",
  selectCategoryFirst: "Please select a category first",
  modeOfExamRequired: "Mode of Exam is required",
  pleaseSelectExcelFile: "Please select an Excel file to upload.",
  onlyExcelFilesAllowed: "Only Excel files (.xlsx) are allowed",
  selectAllFilters: "Please select Class, Section and Exam Name",
  childRequired: "Child is required",
  toDateAfterFrom: "To Date must be after From Date",
  reasonRequired: "Reason is required",
  noteRequired: "Note is required",
  remarkRequired:
    "Please select an action (Approve / Reject / Attach Medical Certificate)",
  holidayTypeRequired: "Holiday Type is required",
  toDateAfterOrSameAsFrom: "To Date must be after or same as From Date",
  descriptionRequired: "Description is required",
  toDateCannotBeBeforeFrom: "To Date cannot be before From Date",
  admissionTypeRequired: "Admission Type is required",
  admissionNameRequired: "Admission Name is required",
  admissionStartDateRequired: "Admission Start Date is required",
  admissionEndDateRequired: "Admission End Date is required",
  screeningStartDateRequired: "Screening Start Date is required",
  screeningEndDateRequired: "Screening End Date is required",
  interviewStartDateRequired: "Interview Start Date is required",
  interviewEndDateRequired: "Interview End Date is required",
  completionDateRequired: "Completion Date is required",
  studentNameTamilRequired: "Student's Name (Tamil) is required",
  studentNameEnglishRequired: "Student's Name (English) is required",
  dobInWordsRequired: "DOB in Words is required",
  emailRequired: "Email is required",
  emailInvalid: "Enter a valid email address",
  casteRequired: "Caste is required",
  nationalityRequired: "Nationality is required",
  religionRequired: "Religion is required",
  categoryRequired: "Category is required",
  lastStudiedMediumRequired: "Last Studied Medium is required",
  preferredMediumRequired: "Preferred Medium is required",
  livingWithRequired: "This field is required",
  onlyNumbersAllowed: "Only Numbers Allowed.",
  districtRequired: "District is required",
  parentNameRequired: "Name is required",
  guardianNameRequired: "Name is required",
  occupationRequired: "Occupation is required",
  emisNoInvalid: "Enter a valid EMIS No",
  documentRequired: "Document is required",
  allowedPdfJpgPng: "Allowed: PDF/JPG/PNG.",
  lastStudiedClassRequired: "Last Studied Class is required",
  lastStudiedSchoolRequired: "Last Studied School is required",
  preferredClassRequired: "Preferred Class for Admission is required",
  motherTongueRequired: "Mother Tongue is required",
  preferredFirstLanguageRequired:
    "Preferred First Language to Study is required",
  schoolNameRequired: "School Name is required",
  yearOfStudyRequired: "Year of Study is required",
  identificationMark1Required: "Identification Mark 1 is required",
  identificationMark2Required: "Identification Mark 2 is required",
  placeRequired: "Place is required",
  studentImageRequired: "Student Image is required",
  allowedJpgPng: "Allowed: JPG/PNG images.",
  otpRequired: "OTP is required",
  otpInvalid: "Enter a valid 6-digit OTP",
  reasonForWithdrawRequired: "Reason for Withdraw is required",
  feedbackRequired: "Feedback is required",
  birthPlaceRequired: "Birth Place is required",
  communityCertificateRequired: "Community Certificate is required",
  onlyTamilAllowed: "Please enter only Tamil characters",
  qualifyingExamRequired: "Qualifying Examination is required",
  examBoardRequired: "Examination Board is required",
  qualifiedExamRequired: "Name of Examination Passed is required",
  examMonthYearRequired: "Month and Year is required",
  registerNumberRequired: "Register Number is required",
  preferredStudyCourseRequired: "Course Preferred to Study is required",
  yearOfAdmissionRequired: "Year of Admission is required",
  preferredGroup1Required: "Preferred Group 1 is required",
  mediumLeavingSchoolRequired: "Medium of Instruction is required",
  studiedYearRequired: "Year of Study is required",
  reasonForLeavingRequired: "Reason for leaving is required",
  lastStudiedSchoolNameRequired: "Name of Last Studied School is required",
  emisNoRequired: "EMIS No is required",
  talukRequired: "Taluk is required",
  noStudentsSelected: "No students selected",
  shiftNameRequired: "Shift Name is required",
  shiftTimeInvalid: "Shift end time must be after start time",
  periodsRequired: "Number of Periods is required",
  periodsMin: "Number of Periods must be greater than 0",
  periodsMax: "Number of Periods cannot exceed 20",
  breaksRequired: "Number of Breaks is required",
  breaksMin: "Number of Breaks cannot be negative",
  breaksMax: "Number of Breaks cannot exceed 10",
  typeRequired: "type is required",
  startTimeRequired: "start time is required",
  endTimeRequired: "end time is required",
  endAfterStart: "end time must be after start time",
  withinShift: "must be within shift hours",
  overlapWith: "overlaps with",
  subjectMediumRequired: "Subject Medium is required",
  onlyPdfFilesAllowed: "Only PDF files are allowed",
  fileNameMismatch: "File name does not match the selected",
  expectedFileName: "Expected file name format",
  contentStartPageRequired: "Content Start Page is required",
  contentEndPageRequired: "Content End Page is required",
  bookFirstPageNoRequired: "Book First Page No. is required",
  pdfPageOfBookFirstPageNoRequired:
    "PDF Page of Book First Page No. is required",
  contentEndPageMustBeAfterStart:
    "Content End Page must be greater than or equal to Content Start Page",
  bookFirstPageNoMin: "Book First Page No. must be at least 1",
  pdfPageNoMin: "PDF Page of Book First Page No. must be at least 1",
  bookRequired: "Book is required",
  topicRequired: "Topic is required",
  startPageRequired: "Start page is required",
  timeDurationRequired: "Time duration is required",
  endPageRequired: "End page is required",
  scheduleDateRequired: "Schedule date is required",
  pageBetween: "Must be between",
  pageValueBetween: "Value must be between",
  endPageAfterStart: "End page must be greater than or equal to start page",
  invalidSubjectSelection: "You can only select periods with the same subject",
  invalidClassSelection: "You can only select periods with the same class",
  selectAtLeastOneCell: "Please select at least one period to schedule",
  invalidCellStatusSelection:
    "You cannot schedule a period that is already submitted, approved, rejected, re-submitted, or completed.",
  selectTimetableCellFirst:
    "Please select a timetable cell first before choosing a lesson plan.",
  selectLessonPlanFirst: "Please select a lesson plan before submitting.",
  selectRowToDelete: "Please select a row to delete",
  numQuestionsRequired: "Number of Questions is required",
  maxQuestionsAllowed: "Maximum 10 questions allowed",
  minQuestionRequired: "Minimum 1 question required",
  difficultyLevelRequired: "Difficulty Level is required",
  mcqOptionsRequired: "MCQ Options Count is required",
  passPercentageRequired: "Pass Percentage is required",
  subTopicRequired: "Sub Topic is required",
  endPageGreaterStart: "End Page must be >= Start Page",
  startPageMin: "Start Page must be >=",
  endPageMax: "End Page must be <=",

  // ==================== Error Labels ====================
  unableToLoadData: "Unable to load data. Please try again later.",
  interviewSaveFailed: "Failed to save interview schedule.",
  profileUpdateFailed: "Failed to update profile. Please try again.",
  noSentMessagesFound: "No sent messages found",
  noMessagesFound: "No messages found",
  fileUploadFailed: "Failed to upload file. Please try again.",
  academicSaveFailed:
    "Failed to save academic configuration. Please try again.",
  somethingWrong: "Something went wrong!",
  noExamResultFound: "There is no Exam Result for this class.",
  noRecordsToDisplay: "No records to display",
  failedToDownload: "Failed to download student list",
  saveFailed: "Failed to save. Please try again.",
  fetchFailed: "Failed to fetch details. Please try again.",
  deleteFailed: "Failed to delete.",
  bulkUploadFailed: "Failed to upload file. Please try again.",
  markBulkUploadFailed: "Failed to upload marks. Please try again.",
  marksAlreadyExist: "Marks already exist",  downloadFailed: "Failed to download Excel. Please try again.",
  publishFailed: "Failed to publish result.",
  studentsFailed: "Students Failed",
  noStudentsFound: "No students found",
  attendanceSaveFailed: "Failed to save attendance. Please try again.",
  leaveSaveFailed: "Failed to save leave request. Please try again.",
  leaveApprovalFailed: "Failed to update leave status. Please try again.",
  holidaySaveFailed: "Failed to save holiday. Please try again.",
  holidayFetchFailed: "Failed to fetch holiday details. Please try again.",
  error: "Error Loading Data",
  studentFailed: "Student Failed",
  updateFailed: "Failed to update. Please try again.",
  bulkStatusChangeFailed: "Failed to update status. Please try again.",
  checklistUpdateFailed: "Checklist update failed",
  somethingWentWrongTryAgain: "Something went wrong. Please try again.",
  somethingWentWrong: "Something went wrong",
  failedToLoadPdf: "Failed to load PDF",
  noHistoryFound: "No history found",
  noSavedLessonPlans: "No saved lesson plans found",
  failedToLoadLessonPlan: "Failed to load lesson plan",
  somethingWentWrongGenerate:
    "Something went wrong while generating the lesson plan.",
  somethingWentWrongSave: "Something went wrong while saving the lesson plan.",
  noTimetableFound: "No timetable found for this week.",
  statusUpdateFailed: "Status update failed",
  failedToFetchLessonPlan: "Failed to fetch lesson plan",
  noQuestionsGenerated: "No questions generated yet",
  failedToFetchAssessment: "Failed to fetch assessment details",
  noExamDataAvailable: "No exam data available yet",
  noAbsenteeToday: "There is no absentee for today",
  noAttendanceDataAvailable: "No attendance data available",
  noDataAvailable: "No data available",

  // ==================== Notification Labels ====================
  interviewInviteSentSuccess: "Interview invite sent successfully!",
  interviewCreateSuccess: "Interview schedule created successfully!",
  interviewUpdateSuccess: "Interview schedule updated successfully!",
  profileUpdateSuccess: "Profile updated successfully!",
  messageSentSuccess: "Message sent successfully",
  academicCreatedSuccess: "Academic configuration created successfully!",
  academicUpdatedSuccess: "Academic configuration updated successfully!",
  createSuccess: "Created successfully!",
  updateSuccess: "Updated successfully!",
  deleteSuccess: "Deleted successfully!",
  bulkUploadSuccess: "File uploaded successfully!",
  markBulkUploadSuccess: "Marks uploaded successfully!",
  publishSuccess: "Result published successfully!",
  attendanceSaveSuccess: "Attendance saved successfully!",
  attendanceUpdateSuccess: "Attendance updated successfully!",
  leaveCreateSuccess: "Leave request created successfully!",
  leaveUpdateSuccess: "Leave updated successfully!",
  leaveApprovalSuccess: "Leave status updated successfully!",
  holidayCreateSuccess: "Holiday created successfully!",
  holidayUpdateSuccess: "Holiday updated successfully!",
  bulkStatusChangeSuccess: "Status updated successfully!",
  checklistUpdateSuccess: "Checklist updated successfully",
  statusChangedSuccess: "Status changed successfully!",
  seatAllocatedSuccess: "Seat allocated successfully",
  lessonPlanUpdatedSuccess: "Lesson plan updated successfully!",
  lessonPlanCreatedSuccess: "Lesson plan created successfully!",
  lessonPlanScheduledSuccess: "Lesson plan scheduled successfully",
  statusUpdateSuccess: "Status updated successfully",
  assessmentGeneratedSuccess: "Assessment generated successfully",
  assessmentSavedSuccess: "Assessment saved successfully",
  copied: "Copied!",

  // Fees Management
  groupFee: "Group Fee",
  demandDate: "Demand Date",
  dueDate: "Due Date",
  option: "Option",
  downloading: "Downloading...",
  createGroupFee: "Create Group Fee",
  editGroupFee: "Edit Group Fee",
  feeList: "Fee List",
  discountFeeList: "Discount Fees",
  groupFeesConfiguration: "Group Fees Configuration",
  discountFeeType: "Discount Fees",
  totalAmount: "Total Amount",
  totalDiscountAmount: "Total Discount Amount",
  fineAmount: "Fine Amount",
  enterAmount: "Enter Amount",
  enterFineAmount: "Enter Fine Amount",
  enterGroupName: "Enter Group Name",
  selectFeeType: "Select Fee Type",
  selectOneOrMoreFeeType: "Select one or more Fee Type",
  selectDiscountFeeType: "Select one or more Discount",
  enterDescriptionMaxWords: "Enter Description (Max : 100 words)",
  specialCharactersNotAllowed: "Special characters and emojis are not allowed",
  groupNameRequired: "Group Name is required",
  feeTypeRequired: "Fee Type is required",
  amountRequired: "Amount is required",
  demandDateRequired: "Demand Date is required",
  dueDateRequired: "Due Date is required",
  fineAmountRequired: "Fine Amount is required",
  dueDateAfterDemand: "Due Date must be after Demand Date",
  amount: "Amount",
  discount: "Discount",
  discountAmount: "Discount Amount",
  selectDiscount: "Select Discount (Optional)",
  deleteGroupFee: "Delete Group Fee",
  groupFeeCreatedSuccess: "Group Fee created successfully!",
  groupFeeUpdatedSuccess: "Group Fee updated successfully!",
  groupFeeDeletedSuccess: "Group Fee deleted successfully!",
  confirmDeleteMessage: "Are you sure you want to delete?",
  onlyJpegPngAllowed: "Only jpeg, png files are allowed",

  // ── Fee Reports ──
  searchDueFeesReport: "Search Due Fees Report",
  dateRange: "Date Range",
  totalDemand: "Total Demand",
  outstanding: "Outstanding",
  ofTotalDemand: "of Total Demand",
  downloadAsExcel: "Download as Excel",
  downloadAsPdf: "Download as PDF",
  emisIdAdmissionId: "Emis ID / Admission ID",
  chalanNo: "Chalan No.",
  paidAmount: "Paid Amount (₹)",
  dueAmount: "Due Amount",
  paymentMode: "Payment Mode",
  upiTransactionId: "UPI Transaction ID",
  paid: "Paid",
  searchByStudentNameChalanId: "Search by student name, Chalan ID",
  noRecordsFound: "No records found",
  dueFeesReport: "Due Fees Report",
  discountsReport: "Discounts Report",
  discountCategory: "Discount Category",
  selectDiscountCategory: "Select Discount Category",
  discountCategoryWise: "Discount Category wise",
  discountedAmount: "Discounted Amount",
  studentsBenefited: "Students Benefited",
  totalDiscountedAmount: "Total Discounted Amount",
  averageDiscount: "Average Discount",
  perStudent: "per student",
  chartView: "Chart View",
  tableView: "Table View",
  allFeesTransactionsReport: "All Fees Transactions Report",
  regularTransaction: "Regular Transaction",
  admissionTransaction: "Admission Transaction",
  selectPaymentMode: "Select Payment Mode",
  online: "Online",
  cash: "Cash",
  transactionId: "Transaction ID",
  emisId: "Emis ID",
  admissionId: "Admission ID",
  upiReferenceId: "UPI Reference ID",
  adminApprovalStatus: "Admin Approval Status",
  feesPaidStatus: "Fees Paid Status",
  pendingApproval: "Pending Approval",
  partlyPaid: "Partly Paid",
  totalTransactions: "Total Transactions",
  totalPaidAmount: "Total Paid Amount",
  approvedTransactions: "Approved Transactions",
  successRate: "Success",
  pendingRate: "Pending",
};

export default en;
